import { Component, signal } from '@angular/core';

@Component({
  selector: 'app-support-faq',
  standalone: true,
  imports: [],
  templateUrl: './support-faq.html',
  styleUrl: './support-faq.css',
})
export class SupportFaq {
 
  readonly activeId = signal<number | null>(null);

  faqs = [
    { 
      id: 1, 
      question: 'আপনাদের কোন সুনির্দিষ্ট সাপোর্ট পলিসি আছে?', 
      answers: ['হ্যাঁ, আমাদের খুব স্পষ্ট ও সুনির্দিষ্ট সাপোর্ট পলিসি রয়েছে- '], 
      link: 'https://edumanbd.com/support-policy' 
    },
    { 
      id: 2, 
      question: 'স্থানীয় প্রতিনিধি ছাড়া কি যথাযথ সাপোর্ট পাওয়া সম্ভব?', 
      answers: [
        'অবশ্যই- এটি গ্যারান্টেড। Eduman এর এমন কোন সাপোর্ট প্রয়োজন হয়না যা, ফেইস টু ফেইস গিয়ে ডেলিভার করার মত। সবকিছুই রিমোটলি/ভার্চুয়্যালি/অনলাইনেই সম্ভব।',
        'বর্তমানে আমাদের খুবই সহজ, সংক্ষিপ্ত ও স্পষ্ট ভিডিও টিউটোরিয়াল রয়েছে। যা আপনার প্রতিষ্ঠানের যে কেউ সহজেই বুঝতে পারবেন- https://edumanbd.com/video-tutorial',
        'বর্তমানে প্রায় সবাই ইন্টারনেট, হোয়াটসঅ্যাপ, ইত্যাদি ব্যবহার করতে পারেন। অথচ বিষয়টি একসময়, খুব দুঃসাধ্য ছিল। ফলে, বর্তমানে আর স্থানীয় প্রতিনিধি প্রয়োজন নেই।'
      ] 
    },
    { id: 3, question: 'মেন্টরইআরপি এর কোন প্রশিক্ষণ ব্যবস্থা আছে কি?', answers: ['আমরা নিয়মিত ট্রেনিং সেশন এবং অনলাইন টিউটোরিয়াল প্রদান করি।'] },
    { id: 4, question: 'মেন্টরইআরপি   সার্টিফাইড হতে হলে কি কি করতে হবে?', answers: ['নির্ধারিত কোর্স সম্পন্ন করে অ্যাসেসমেন্টে উত্তীর্ণ হতে হবে।'] },
    { id: 5, question: 'মেন্টরইআরপি   সফটওয়্যারের ব্যাকআপ কিভাবে নিব?', answers: ['সিস্টেম থেকে অটোমেটিক ক্লাউড ব্যাকআপের সুবিধা রয়েছে।'] },
    { id: 6, question: 'মেন্টরইআরপি   থেকে অন্য সফটওয়্যারে মাইগ্রেট করা যাবে?', answers: ['হ্যাঁ, এক্সেল ডাটা ইম্পোর্ট/এক্সপোর্ট এর মাধ্যমে মাইগ্রেট করা সম্ভব।'] },
    { id: 7, question: 'মেন্টরইআরপি   সার্ভার কি হঠাৎ বন্ধ থাকতে পারে?', answers: ['না, আমাদের সার্ভার উচ্চ ক্ষমতা সম্পন্ন এবং ২৪/৭ সচল থাকে।'] },
    { id: 8, question: 'অফলাইনে কি কাজ করা যায়?', answers: ['মেন্টরইআরপি মূলত অনলাইন বেসড সফটওয়্যার, তাই ইন্টারনেটের প্রয়োজন হয়।'] }
  ];

  toggleFaq(id: number) {
   
    this.activeId.update(current => current === id ? null : id);
  }
}

